module.exports = __webpack_public_path__ + "static/media/017.4fdf5c1d.jpg";